import React, { useContext, useState, useEffect } from 'react'
import { errorToast, successToast } from '../../../utils/notificationUtils'
import SettingHandler from '../../../Apihander/setting/settingHandler'
import { useForm } from 'react-hook-form'
import ContactHandler from '../../../Apihander/Contact/ContactHandler'
import { useNavigate } from 'react-router-dom'

const Support = () => {
  const { register, handleSubmit, formState: { errors }, watch, reset } = useForm();
  const navigate = useNavigate()
  const [loading, setLoading] = useState('')
  const [widgetLoaded, setWidgetLoaded] = useState(false); // State to track if widget is loaded





  const onsubmit = async (data) => {
    // console.log(window.FreshworksWidget); // Check if widget exists
    // console.log(data); // Log form data

    try {
      setLoading(true)

      if (widgetLoaded && window.FreshworksWidget) {
        // Append the name, email, and message from the form data to the Freshdesk widget
        window.FreshworksWidget('identify', 'ticketForm', {
          name: data.name,
          email: data.email,
          description: data.message,
        });
        successToast('Your message has been sent to the support team.');
        reset(); // Reset the form after submission
        setLoading(false);
      } else {
        throw new Error("FreshworksWidget not loaded");
      }
    } catch (error) {
      console.log(error);
      errorToast("An error occurred while sending your message.");
      setLoading(false);
    }
  }



  return (
    <div className='vr-set-page'>
      <h2 className="vr-set-title">
        Support
      </h2>
      <form
        className='vr-set-card'
        onSubmit={handleSubmit(onsubmit)}
        noValidate
      >
        <div className="vr-set-form">
          <div className="form-group vr-set-field">
            <label className="vr-set-label" htmlFor="name">Your Name</label>
            <input type="text" id="name" name="name" placeholder="Enter your name"
              className={`vr-input vr-set-input ${errors.name ? 'is-error' : ''}`}
              {...register("name", {
                required: 'This field is required',
                minLength: {
                  value: 4,
                  message: 'Name should be more than 3 letters'
                }
              })} />
            {errors.name && <span className="error-message vr-set-error">{errors.name.message}</span>}

          </div>
          <div className="form-group vr-set-field">
            <label className="vr-set-label" htmlFor="email">Email</label>
            <input type="text" id="email" name="email" placeholder="Enter your email"
              className={`vr-input vr-set-input ${errors.email ? 'is-error' : ''}`}

              {...register("email", {
                required: 'This field is required',
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: 'Enter a valid email address'
                }
              })}
            />
            {errors.email && <span className="error-message vr-set-error">{errors.email.message}</span>}

          </div>
          <div className="form-group vr-set-field">
            <label className="vr-set-label" htmlFor="message">Message</label>
            <textarea id="message" name="message" placeholder="Enter your message"
              //  className="form-control input-field"
              className={`vr-input vr-set-input ${errors.message ? 'is-error' : ''}`}
              {...register("message", {
                required: 'This field is required',
                minLength: {
                  value: 0,
                  message: 'message should be more than 10 letters'
                }
              })} />

            {errors.message && <span className="error-message vr-set-error">{errors.message.message}</span>}

          </div>

        </div>

        <div className="vr-set-actions">
          <div className="form-group">
            <button type='submit'
              className='vr-btn vr-btn-primary vr-btn-lg'
              style={{ cursor: loading ? 'not-allowed' : 'pointer' }}
              disabled={loading}>
              {loading ? (
                <>
                  <div
                    className="spinner-border vr-set-spin"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </>
              ) : (
                <span>Submit</span>
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}



export default Support
